import * as _ from 'lodash'
import React from 'react';
import * as actions from '../actions';
import util from '../util';
import componentServices from '../componentServices';
import { Avatar, AsyncContent, Expander, SearchForm, sortableComponent } from './sharedComponents';
import { DomainEntityType, getCollection, getDomainEntities, ModelCollection } from '../store';

const UserTable = sortableComponent(({ updateSort, sortKey, list, ...childProps }) => {
	return (
		<table className="sortable interactive" cellPadding="0" cellSpacing="0">
			<UserTableHeader updateSort={updateSort} sortKey={sortKey} {...childProps} />
			<UserTableBody employeesCursor={list} {...childProps} />
		</table>
	);
});

class UserTableHeader extends React.Component<any> {
	handleClick (k, e) {
		e.preventDefault();
		this.props.updateSort(k);
	}

	getClassName (key) {
		return (key === this.props.sortKey) ? 'sorted' : '';
	}

	render () {
		return (
			<thead>
				<tr>
					<td />
					<td />
					<td className={this.getClassName('lastName')} onClick={this.handleClick.bind(this, 'lastName')}>Last</td>
					<td className={this.getClassName('firstName')} onClick={this.handleClick.bind(this, 'firstName')}>First</td>
					<td className={this.getClassName('userName')} onClick={this.handleClick.bind(this, 'userName')}>Username</td>
					<td className={this.getClassName('emailAddress')} onClick={this.handleClick.bind(this, 'emailAddress')}>Email</td>
					<td className={this.getClassName('accountingId')} onClick={this.handleClick.bind(this, 'accountingId')}>Accounting ID</td>
					<td className={this.getClassName('workPhoneNumber')} onClick={this.handleClick.bind(this, 'workPhoneNumber')}>Office</td>
					<td className={this.getClassName('mobilePhoneNumber')} onClick={this.handleClick.bind(this, 'mobilePhoneNumber')}>Mobile</td>
					<td className={this.getClassName('orgTitleKey')} onClick={this.handleClick.bind(this, 'orgTitleKey')}>Job Title</td>
					<td className={this.getClassName('orgDepartmentKey')} onClick={this.handleClick.bind(this, 'orgDepartmentKey')}>Department</td>
					<td className={this.getClassName('formattedModules')} onClick={this.handleClick.bind(this, 'formattedModules')}>Permissions</td>
					<td />
				</tr>
			</thead>
		);
	}
}

const UserTableBody = ({ employeesCursor, ...childProps }) => {
	const rows:JSX.Element[] = [];
	
	employeesCursor.forEach(function (employee) {
		rows.push(<UserTableRow employee={employee} key={employee.key} {...childProps} />);
	});

	return (<tbody>{rows}</tbody>);
};

class UserTableRow extends React.Component<any> {
	constructor (props) {
		super(props);

		this.handleClick = this.handleClick.bind(this);
	}

	handleClick (e) {
		const { employee } = this.props;

		e.preventDefault();
		componentServices.router.pushHistory(componentServices.router.pushPathSegment(employee.key));
	}

	render () {
		const { employee } = this.props;
		const mailto = 'mailto:' + employee.emailAddress;

		const orgTitles = getDomainEntities({ store: componentServices.store, type: DomainEntityType.orgTitles });
		const orgDepartments = getDomainEntities({ store: componentServices.store, type: DomainEntityType.orgDepartments });
		const title = (employee.orgTitleKey) ? orgTitles[employee.orgTitleKey].name : '';
		const dept = (employee.orgDepartmentKey) ? orgDepartments[employee.orgDepartmentKey].name : '';

		return (
			<tr onClick={this.handleClick}>
				<td />
				<td><Avatar imageUrl={employee.avatarUrl} /></td>
				<td>{employee.lastName}</td>
				<td>{employee.firstName}</td>
				<td>{employee.user.userName}</td>
				<td><a href={mailto}>{employee.emailAddress}</a></td>
				<td>{employee.accountingId}</td>
				<td className="nowrap">{employee.workPhoneNumber}</td>
				<td className="nowrap">{employee.mobilePhoneNumber}</td>
				<td>{title}</td>
				<td>{dept}</td>
				<td>{employee.formattedModules}</td>
				<td />
			</tr>
		);
	}
}

export default class AdminDashboard extends React.Component<any, any> {
	constructor (props) {
		super(props);

		this.state = { searchText: '' };

		this.onSearch = this.onSearch.bind(this);
		this.handleAddUserClick = this.handleAddUserClick.bind(this);
	}

	onSearch ({ searchText }) {
		this.setState(previousState=>{
			const nextState = _.assign({}, previousState);

			nextState.searchText = searchText;

			return nextState;
		});
	}

	handleAddUserClick (e) {
		e.preventDefault();
		componentServices.router.pushHistory(componentServices.router.pushPathSegment(util.generateGuid()));
	}

	componentDidMount () {
		actions.setHeaderAction({
			key: 'employee-add-action',
			element: <button className="icon addPerson" onClick={this.handleAddUserClick}><span /></button>
		});
	}

	componentWillUnmount () {
		actions.deleteHeaderAction({ key: 'employee-add-action' });
	}

	_getFilteredList (list) {
		const searchText = this.state.searchText && this.state.searchText.toLowerCase();

		if (!searchText) { return list; }
		return list.filter((v) => {
			return (v.lastName && v.lastName.toLowerCase().indexOf(searchText) !== -1)
				|| (v.firstName && v.firstName.toLowerCase().indexOf(searchText) !== -1)
				|| (v.userName && v.userName.toLowerCase().indexOf(searchText) !== -1)
				|| (v.emailAddress && v.emailAddress.toLowerCase().indexOf(searchText) !== -1)
				|| (v.accountingId && v.accountingId.toLowerCase().indexOf(searchText) !== -1)
				|| (v.formattedModules && v.formattedModules.toLowerCase().indexOf(searchText) !== -1);
		});
	}

	render () {
		const allEmployees = getCollection({ store: componentServices.store, collection: ModelCollection.employees });
		const activeList = this._getFilteredList(allEmployees.filter(e => !e.inactive));
		const inactiveList = this._getFilteredList(allEmployees.filter(e => e.inactive));
		const titleActive = "Active Employees";
		const titleInactive = "Inactive Employees";
		const { emptyTitle } = this.props;

		return (
			<div>
				<SearchForm onSearch={this.onSearch} />

				<Expander title= {titleActive}>
					<AsyncContent emptyContent = { emptyTitle } hasData={ activeList.count() } ><UserTable list={ activeList } initialSortKey="lastName" /></AsyncContent>
				</Expander>

				<Expander title= {titleInactive}>
					<AsyncContent emptyContent = { emptyTitle } hasData={ inactiveList.count() } ><UserTable list={ inactiveList } initialSortKey="lastName" /></AsyncContent>
				</Expander>

			</div>
		);
	}
}